'use strict';

import authentication from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        token: undefined,
        userInfo: undefined
    },
    getters: {
        getToken: (state) => state.token,
        getUserInfo: (state) => state.userInfo
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload;
        },
        SET_USER_INFO(state, payload) {
            state.userInfo = payload;
        },
        SET_IS_ADMIN(state, payload) {
            state.isAdmin = payload;
        },
        CLEAR_STATE(state) {
            state.token = undefined;
            state.userInfo = undefined;
        }
    },
    actions: {
        setToken(context, payload) {
            context.commit('SET_TOKEN', payload);
        },
        preLogin(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/pre-login', data, config })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        validateOtp(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/validate-otp', data, config })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        login(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/login', data, config })
                    .then((response) => {
                        if (response.access_token) {
                            let { access_token } = response;
                            if (access_token) {
                                response.access_token = window.btoa(access_token); // Encode To Base64
                                context.commit('SET_TOKEN', response.access_token);
                                // context.commit('SET_USER_INFO', response.data);
                                resolve(response);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        logout(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/logout', config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        registerUser(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/register', data, config })
                    .then((response) => {
                        // console.log(response);
                        response.access_token = window.btoa(response.access_token); // Encode To Base64
                        context.commit('SET_TOKEN', response.access_token);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchUserInfo(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .getData({ to: '/auth/me', config })
                    .then((response) => {
                        if (response.data) {
                            context.commit('SET_USER_INFO', response.data);
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                        // context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        forgotPassword(context, payload) {
            let { data } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/password-reset/email', data })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        // context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        resetPassword(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/password-reset', data, config })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        // context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        validateRegistrationToken(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .postData({ to: '/auth/verify/token', data, config })
                    .then((response) => {
                        // console.log(response);
                        if (response.data) {
                            context.commit('SET_USER_INFO', response.data);
                            resolve(response);
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                        // context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        async refreshToken(context) {
            try {
                const data = await authentication.postData({ to: '/auth/refresh' });
                data.access_token = window.btoa(data.access_token);
                context.commit('SET_TOKEN', data.access_token);
                return data;
            } catch (error) {
                return error;
            }

            // return new Promise((resolve, reject) => {
            //     authentication.postData({ to: '/auth/refresh' }).then((response) => {
            //         response.access_token = window.btoa(response.access_token)
            //         context.commit('SET_TOKEN', response.access_token);
            //         resolve(response)
            //     })
            //     .then((error) => {
            //         reject(error)
            //     })
            // })
        },
        fetchCSRFToken(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                authentication
                    .getData({ to: '/auth/csrf-cookie', config })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};
